import { AuditActorType } from '../../dtos/AuditActorType';
import { AuditCategory } from '../../dtos/AuditCategory';
import { Modules } from '../../dtos/Modules';
import { UserRole } from '../../dtos/UserRole';
import type { AuditEntryDto } from '../../dtos/AuditEntryDto';

export const MODULE_LABELS: Record<number, string> = {
    [Modules.PA]: 'Pre-Award',
    [Modules.DC]: 'Design & Construction',
    [Modules.AP]: 'Award Processing',
    [Modules.CO]: 'Closeout',
    [Modules.FO]: 'Financial Oversight',
};

export const ROLE_LABELS: Record<number, string> = {
    [UserRole.ORF_DTR]: 'ORF-DTR',
    [UserRole.ORF_DEP]: 'ORF-DEP',
    [UserRole.PO]: 'PO',
    [UserRole.GMS]: 'GMS',
    [UserRole.PI]: 'PI',
    [UserRole.SO]: 'SO',
    [UserRole.PO_SUPERVISOR]: 'PO (Supervisor)',
    [UserRole.GMS_SUPERVISOR]: 'GMS (Supervisor)',
    [UserRole.ORF_DTR_SUPERVISOR]: 'ORF-DTR (Supervisor)',
    [UserRole.EXTERNAL_USER]: 'External User',
    [UserRole.EXTERNAL_REVIEWER]: 'Reviewer',
    [UserRole.EXTERNAL_AE_DESIGNER]: 'A/E Designer',
    [UserRole.EXTERNAL_PROJECT_MANAGER]: 'Project Manager',
    [UserRole.SU]: 'Superuser',
};

export const CATEGORY_LABELS: Record<number, string> = {
    [AuditCategory.Tasklist]: 'Tasklist',
    [AuditCategory.File]: 'Files',
    [AuditCategory.Comment]: 'Comments',
    [AuditCategory.Grant]: 'Grant',
    [AuditCategory.Notification]: 'Notifications',
    [AuditCategory.Admin]: 'Administration',
    [AuditCategory.User]: 'Users',
};

// Who did it, as one string. A system row names the job instead of a person, because there was no
// person: "System (DailyGrantProcessing)".
export const actorLabel = (entry: AuditEntryDto): string => {
    if (entry.actorType === AuditActorType.System) {
        return entry.source ? `System (${entry.source})` : 'System';
    }

    return entry.userName || 'Unknown user';
};

export const roleLabel = (role: UserRole | null | undefined): string =>
    role === null || role === undefined ? '' : ROLE_LABELS[role] ?? String(role);
